import React from "react";

import {
  Create,
  TextInput,
  SimpleForm,
  required,
  useNotify,
  useRefresh,
  useRedirect,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

export const CatalogSamplesCreate = (props) => {
  const classes = useCreateStyles();

  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const onSuccess = () => {
    notify(`Catalog samples created`);
    sleep(2000).then(() => {
      redirect("/catalog_samples");
      refresh();
    });
  };

  return (
    <Create
      title="Create Catalog Sample"
      undoable={false}
      onSuccess={onSuccess}
      submitOnEnter={true}
      actions={<MyCreateActions />}
      classes={classes}
      {...props}
    >
      <SimpleForm>
        <TextInput
          label="Code"
          source="code"
          validate={required("Code is required")}
        />
        <TextInput
          multiline
          minRows={4}
          source="short_description"
          label="Short Description"
          validate={required("Short description is required")}
        />
      </SimpleForm>
    </Create>
  );
};
